import Vuex from 'vuex';

import sortBy from 'lodash/sortBy';

import actions from './actions';
import Auction from './entity/auction';

export default () =>
  new Vuex.Store({
    state() {
      return {
        apiPath: process.env.API_PATH,
        isLoading: false,
        isTimerInitialized: false,
        userId: 0,
        now: new Date().getTime(),
        auctions: [],
        auctionsStatus: null,
        stats: {
          auctions: 0,
          bids: 0,
        },
        statsStatus: null,
        timer: null,
        timeDelta: 0,
        bidsQueue: [],
        bidsListener: null,
      };
    },
    actions,
    mutations: {
      setLoading() { },
      addAuction(state, params) {
        state.auctions.push(new Auction(params));
      },
      cancelAuction(state, params) {
        const auction = state.auctions.find(
          a => a.appointmentId === params.appointmentId,
        );

        if (auction) {
          auction.hide(() => {
            state.auctions.splice(state.auctions.indexOf(auction), 1);
          });
        }
      },
      sortAuctions(state) {
        state.auctions = sortBy(state.auctions, auction =>
          auction.getSortValue(),
        );
      },
      stopTimer(state) {
        clearInterval(state.timer);
      },
      initTimer(state, delta) {
        clearInterval(state.timer);

        state.timeDelta = Math.abs(delta) > 5 ? delta : delta - (delta % 5);

        state.timer = setInterval(() => {
          const nowDate = new Date();
          state.now = nowDate.getTime();
          const now = Math.floor(state.now / 1000);

          state.auctions.forEach((auction) => {
            if (auction.status === 'active') {
              const seconds = auction.timeFinish - (state.timeDelta || 0) - now;

              auction.update({ secondsLeft: seconds > 0 ? seconds : 0 });

              if (seconds < -1) {
                auction.update({ status: 'bids_confirm' });
              }
            }
          });
        }, 100);

        setTimeout(() => {
          state.isTimerInitialized = true;
        }, 100);
      },

      setUserId(state, userId) {
        state.userId = userId;
      },

      updateOrCreateAuction(state, params) {
        let auction = state.auctions.find((item) => {
          if (!!params.id && !!item.id) {
            return parseInt(item.id, 10) === parseInt(params.id, 10);
          }

          return (
            parseInt(item.appointmentId, 10) ===
            parseInt(params.appointmentId, 10)
          );
        });

        if (!auction) {
          auction = new Auction(params);
          auction.show();
          state.auctions.splice(0, 0, auction);
          state.stats.auctions += 1;
          return;
        }

        if (params.status === 'wait_client') {
          auction.hide(() => {
            state.auctions.splice(state.auctions.indexOf(auction), 1);
          });
        } else {
          auction.update(params);
        }
      },
      updateAuction(state, params) {
        const auction = state.auctions.find((item) => {
          if (params.id && item.id) {
            return parseInt(item.id, 10) === parseInt(params.id, 10);
          } else if (item.carId && params.carId) {
            return parseInt(item.carId, 10) === parseInt(params.carId, 10);
          }

          return (
            parseInt(item.appointmentId, 10) ===
            parseInt(params.appointmentId, 10)
          );
        });

        if (auction) {
          auction.update(params);
        } else {
          const newAuction = new Auction(params);
          newAuction.show();
          state.auctions.push(newAuction);
        }
      },
      updateAuctionStatus(state, { id, status, done = () => { } }) {
        const auction = state.auctions.find(a => a.id === id);

        if (!!auction && status && auction.status !== status) {
          const updatedAuction = new Auction(auction);
          updatedAuction.status = status;

          auction.status = status;
          done();
        } else {
          done();
        }
      },
      setAuctionsStatus(state, val) {
        state.auctionsStatus = val;
      },
      setStats(state, stats) {
        state.stats = stats;
        state.statsStatus = 'ready';
      },
      setStatsStatus(state, val) {
        state.statsStatus = val;
      },
      clearAuctionQueue(state, auctionId) {
        const auctionInQueue = state.bidsQueue.find(a => a.id === auctionId);

        if (auctionInQueue) {
          state.bidsQueue.splice(state.bidsQueue.indexOf(auctionInQueue), 1);
        }
      },
    },
    getters: {},
  });



// WEBPACK FOOTER //
// ./src/store/index.js